/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AnalyzeAndGenerateRequestRequest,
  AnalyzeAndGenerateResponse,
  GeneratedIdea,
  GeneratedIdeaRequest,
  IdeaApproveRequest,
  IdeaGenerationRequestRequest,
  IdeaGenerationTaskResponse,
  IdeaListParams,
  PaginatedGeneratedIdeaListList,
} from "../../models";

import { customInstance } from "../../custom-instance";
import type { ErrorType, BodyType } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * 사용자의 생성된 플레이리스트 아이디어 목록을 조회합니다.
 * @summary 아이디어 목록 조회
 */
export const ideaList = (
  params?: IdeaListParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PaginatedGeneratedIdeaListList>(
    { url: `/api/ai-agent/ideas/`, method: "GET", params, signal },
    options,
  );
};

export const getIdeaListQueryKey = (params?: IdeaListParams) => {
  return [`/api/ai-agent/ideas/`, ...(params ? [params] : [])] as const;
};

export const getIdeaListQueryOptions = <
  TData = Awaited<ReturnType<typeof ideaList>>,
  TError = ErrorType<unknown>,
>(
  params?: IdeaListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof ideaList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getIdeaListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof ideaList>>> = ({
    signal,
  }) => ideaList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof ideaList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type IdeaListQueryResult = NonNullable<
  Awaited<ReturnType<typeof ideaList>>
>;
export type IdeaListQueryError = ErrorType<unknown>;

export function useIdeaList<
  TData = Awaited<ReturnType<typeof ideaList>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | IdeaListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof ideaList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ideaList>>,
          TError,
          Awaited<ReturnType<typeof ideaList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useIdeaList<
  TData = Awaited<ReturnType<typeof ideaList>>,
  TError = ErrorType<unknown>,
>(
  params?: IdeaListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof ideaList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ideaList>>,
          TError,
          Awaited<ReturnType<typeof ideaList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useIdeaList<
  TData = Awaited<ReturnType<typeof ideaList>>,
  TError = ErrorType<unknown>,
>(
  params?: IdeaListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof ideaList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 아이디어 목록 조회
 */

export function useIdeaList<
  TData = Awaited<ReturnType<typeof ideaList>>,
  TError = ErrorType<unknown>,
>(
  params?: IdeaListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof ideaList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getIdeaListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 특정 아이디어의 상세 정보를 조회합니다.
 * @summary 아이디어 상세 조회
 */
export const ideaRetrieve = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GeneratedIdea>(
    { url: `/api/ai-agent/ideas/${id}/`, method: "GET", signal },
    options,
  );
};

export const getIdeaRetrieveQueryKey = (id?: string) => {
  return [`/api/ai-agent/ideas/${id}/`] as const;
};

export const getIdeaRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof ideaRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof ideaRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getIdeaRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof ideaRetrieve>>> = ({
    signal,
  }) => ideaRetrieve(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof ideaRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type IdeaRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof ideaRetrieve>>
>;
export type IdeaRetrieveQueryError = ErrorType<unknown>;

export function useIdeaRetrieve<
  TData = Awaited<ReturnType<typeof ideaRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof ideaRetrieve>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ideaRetrieve>>,
          TError,
          Awaited<ReturnType<typeof ideaRetrieve>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useIdeaRetrieve<
  TData = Awaited<ReturnType<typeof ideaRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof ideaRetrieve>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ideaRetrieve>>,
          TError,
          Awaited<ReturnType<typeof ideaRetrieve>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useIdeaRetrieve<
  TData = Awaited<ReturnType<typeof ideaRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof ideaRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 아이디어 상세 조회
 */

export function useIdeaRetrieve<
  TData = Awaited<ReturnType<typeof ideaRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof ideaRetrieve>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getIdeaRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 아이디어를 승인합니다. auto_generate=true 시 플레이리스트 생성을 시작합니다.
 * @summary 아이디어 승인
 */
export const ideaApprove = (
  id: string,
  ideaApproveRequest: BodyType<IdeaApproveRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GeneratedIdea>(
    {
      url: `/api/ai-agent/ideas/${id}/approve/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: ideaApproveRequest,
      signal,
    },
    options,
  );
};

export const getIdeaApproveMutationOptions = <
  TError = ErrorType<unknown | unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof ideaApprove>>,
    TError,
    { id: string; data: BodyType<IdeaApproveRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof ideaApprove>>,
  TError,
  { id: string; data: BodyType<IdeaApproveRequest> },
  TContext
> => {
  const mutationKey = ["ideaApprove"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof ideaApprove>>,
    { id: string; data: BodyType<IdeaApproveRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return ideaApprove(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type IdeaApproveMutationResult = NonNullable<
  Awaited<ReturnType<typeof ideaApprove>>
>;
export type IdeaApproveMutationBody = BodyType<IdeaApproveRequest>;
export type IdeaApproveMutationError = ErrorType<unknown | unknown>;

/**
 * @summary 아이디어 승인
 */
export const useIdeaApprove = <
  TError = ErrorType<unknown | unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof ideaApprove>>,
      TError,
      { id: string; data: BodyType<IdeaApproveRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof ideaApprove>>,
  TError,
  { id: string; data: BodyType<IdeaApproveRequest> },
  TContext
> => {
  const mutationOptions = getIdeaApproveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 아이디어를 거부합니다.
 * @summary 아이디어 거부
 */
export const ideaReject = (
  id: string,
  generatedIdeaRequest: BodyType<GeneratedIdeaRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GeneratedIdea>(
    {
      url: `/api/ai-agent/ideas/${id}/reject/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: generatedIdeaRequest,
      signal,
    },
    options,
  );
};

export const getIdeaRejectMutationOptions = <
  TError = ErrorType<unknown | unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof ideaReject>>,
    TError,
    { id: string; data: BodyType<GeneratedIdeaRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof ideaReject>>,
  TError,
  { id: string; data: BodyType<GeneratedIdeaRequest> },
  TContext
> => {
  const mutationKey = ["ideaReject"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof ideaReject>>,
    { id: string; data: BodyType<GeneratedIdeaRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return ideaReject(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type IdeaRejectMutationResult = NonNullable<
  Awaited<ReturnType<typeof ideaReject>>
>;
export type IdeaRejectMutationBody = BodyType<GeneratedIdeaRequest>;
export type IdeaRejectMutationError = ErrorType<unknown | unknown>;

/**
 * @summary 아이디어 거부
 */
export const useIdeaReject = <
  TError = ErrorType<unknown | unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof ideaReject>>,
      TError,
      { id: string; data: BodyType<GeneratedIdeaRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof ideaReject>>,
  TError,
  { id: string; data: BodyType<GeneratedIdeaRequest> },
  TContext
> => {
  const mutationOptions = getIdeaRejectMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 트렌드 분석과 아이디어 생성을 한 번에 실행합니다.
 * @summary 트렌드 분석 + 아이디어 생성 통합
 */
export const ideaAnalyzeAndGenerate = (
  analyzeAndGenerateRequestRequest: BodyType<AnalyzeAndGenerateRequestRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<AnalyzeAndGenerateResponse>(
    {
      url: `/api/ai-agent/ideas/analyze-and-generate/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: analyzeAndGenerateRequestRequest,
      signal,
    },
    options,
  );
};

export const getIdeaAnalyzeAndGenerateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof ideaAnalyzeAndGenerate>>,
    TError,
    { data: BodyType<AnalyzeAndGenerateRequestRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof ideaAnalyzeAndGenerate>>,
  TError,
  { data: BodyType<AnalyzeAndGenerateRequestRequest> },
  TContext
> => {
  const mutationKey = ["ideaAnalyzeAndGenerate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof ideaAnalyzeAndGenerate>>,
    { data: BodyType<AnalyzeAndGenerateRequestRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return ideaAnalyzeAndGenerate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type IdeaAnalyzeAndGenerateMutationResult = NonNullable<
  Awaited<ReturnType<typeof ideaAnalyzeAndGenerate>>
>;
export type IdeaAnalyzeAndGenerateMutationBody =
  BodyType<AnalyzeAndGenerateRequestRequest>;
export type IdeaAnalyzeAndGenerateMutationError = ErrorType<unknown>;

/**
 * @summary 트렌드 분석 + 아이디어 생성 통합
 */
export const useIdeaAnalyzeAndGenerate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof ideaAnalyzeAndGenerate>>,
      TError,
      { data: BodyType<AnalyzeAndGenerateRequestRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof ideaAnalyzeAndGenerate>>,
  TError,
  { data: BodyType<AnalyzeAndGenerateRequestRequest> },
  TContext
> => {
  const mutationOptions = getIdeaAnalyzeAndGenerateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 트렌드 분석 결과를 기반으로 플레이리스트 아이디어를 생성합니다.
 * @summary 새 아이디어 생성
 */
export const ideaGenerate = (
  ideaGenerationRequestRequest: BodyType<IdeaGenerationRequestRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<IdeaGenerationTaskResponse>(
    {
      url: `/api/ai-agent/ideas/generate/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: ideaGenerationRequestRequest,
      signal,
    },
    options,
  );
};

export const getIdeaGenerateMutationOptions = <
  TError = ErrorType<unknown | unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof ideaGenerate>>,
    TError,
    { data: BodyType<IdeaGenerationRequestRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof ideaGenerate>>,
  TError,
  { data: BodyType<IdeaGenerationRequestRequest> },
  TContext
> => {
  const mutationKey = ["ideaGenerate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof ideaGenerate>>,
    { data: BodyType<IdeaGenerationRequestRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return ideaGenerate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type IdeaGenerateMutationResult = NonNullable<
  Awaited<ReturnType<typeof ideaGenerate>>
>;
export type IdeaGenerateMutationBody = BodyType<IdeaGenerationRequestRequest>;
export type IdeaGenerateMutationError = ErrorType<unknown | unknown>;

/**
 * @summary 새 아이디어 생성
 */
export const useIdeaGenerate = <
  TError = ErrorType<unknown | unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof ideaGenerate>>,
      TError,
      { data: BodyType<IdeaGenerationRequestRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof ideaGenerate>>,
  TError,
  { data: BodyType<IdeaGenerationRequestRequest> },
  TContext
> => {
  const mutationOptions = getIdeaGenerateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
